import {AppBlock} from "@ok/web/modules/block/AppBlock";
import {RbAdBannerEmergedFooterStore} from "./RbAdBannerEmergedFooterStore";
import {RbAdBannerEmergedFooter} from "../components/RbAdBannerEmergedFooter/RbAdBannerEmergedFooter";
import {RbAdBannerEmergedFooterController} from "./RbAdBannerEmergedFooterController";
import {IRbAdBannerEmergedFooterAttrs} from "./RbAdBannerEmergedFooterAttrs";

export class RbAdBannerEmergedFooterBlock extends AppBlock<IRbAdBannerEmergedFooterAttrs, {}, RbAdBannerEmergedFooterStore, RbAdBannerEmergedFooterController> {
    getAppAPI() {
        return {};
    }

    getAppEntities() {
        return {
            Store: RbAdBannerEmergedFooterStore,
            Controller: RbAdBannerEmergedFooterController,
            Component: RbAdBannerEmergedFooter
        };
    }
}
